// @flow
export default (theme: Object) => ({
    locationTitle: {
        fontFamily: 'Inter',
        fontWeight: 600,
        fontSize: 16,
        marginBottom: 5,
    },
    locationAddress: {
        fontFamily: 'Inter',
        fontSize: 16,
    },
    cardContent: {
        fontFamily: 'Inter',
        fontSize: 16,

        '& $label': {
            fontWeight: 600,
        },
    },
    label: {
        '&:after': {
            content: '":"',
        },
    },
    description: {
        position: 'relative',
        marginBottom: theme.spacing(1),
    },
    showMoreButton: {
        fontFamily: 'Inter',
        fontSize: 16,
        height: 50,
    },
    gradient: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: 40,
        backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0), ${theme.palette.common.white})`,
    },
});
